module.exports = __webpack_public_path__ + "img/timestudy-top.6e90467d.png";